import { useCallback } from 'react';

// TODO: will be done in the next iteration
export function useMouseLeaveHandle(onHover?: (hover: boolean) => void) {
  return useCallback(() => onHover && onHover(false), []);
}
